var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDesktop())?_c('home-page'):_c('phone-home-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }